import React from 'react';
import type { Node } from 'react';
import { useTheme } from '@emotion/react';
import { Icon, useComponentTheme, withSpacingStyles } from '@vmos2/design-system';
import styled from '@emotion/styled';

type Props = {
  color?: string,
  className?: string,
  size?: string,
  mode?: string
};

export const LoyaltyLogo = withSpacingStyles(({ className, color: ownColor, size = '100%', mode }: Props): Node => {
  const theme = useTheme();
  const { logo: componentThemeLogo, visible } = useComponentTheme(theme => theme.components.LoyaltyLogo, mode);
  const logo = componentThemeLogo || theme.loyalty.rewardsPoints.logo;
  const color = ownColor || theme.color.loyalty.logo || theme.color.brand;
  const hasCustomIcon = !!logo;

  if (!visible) return null;

  return hasCustomIcon ? (
    <Logo alt="" data-test="loyalty-logo" className={className} logoSize={size} src={logo} />
  ) : (
    <Logo as={Icon} className={className} data-test="loyalty-logo" fill={color} logoSize={size} name="Diamond" />
  );
});

const Logo = styled('img')(({ logoSize }) => `
  width: ${logoSize};
  height: ${logoSize};
  object-fit: contain;
`);

LoyaltyLogo.displayName = 'LoyaltyLogo';
